import React from "react";
import axios from "axios";
import { notifications } from '@mantine/notifications';
import { Group, Text, Box } from '@mantine/core';
import { Carousel } from '@mantine/carousel';
import { IconTrash } from '@tabler/icons-react';

import { useLoginContext } from "../../context/loginContext";
import { BE_API_TWO, utils, ROOT_BASE_URL } from "../../utils/globalVariables";

import ModalResponse from "../../components/general/ModalResponse";
import ModalTakeAction from "../../components/general/ModalTakeAction";
import InputWrapperCustom from "../../components/general/InputWrapperCustom";
import LabelWithAsterisk from "../../components/general/LabelWithAsterisk";
import BarangProjectNotaFotoFileInput from "./BarangProjectNotaFotoFileInput";

const BarangProjectNotaFoto = ({ stateData, fnOnChange, fnClickPhoto }) => {

    const mountedRef = React.useRef(true);
    const { loginContext, handleSetLoginContext } = useLoginContext();

    const heightImage = 150;

    const notificationId = React.useRef({
        errorDeleteData: 'barangProjectNotaFoto-1',
    })

    const [data, setData] = React.useState({
        deleteModal: false,
        deleteId: '',
        deleteName: '',
        deleteLoading: false,

        camModalShow: false,

        modalResponse: {
            show: false,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: false,
            content: ''
        }
    });

    React.useEffect(() => {
        return () => {
            mountedRef.current = false;
        }
    }, [])

    const deleteData = () => {
        setData(d => ({ ...d, deleteLoading: true }));

        const formDT = new FormData();
        const formDTHeader = { 'Content-Type': 'application/json' }

        formDT.append('json_token', loginContext.syswebapp);
        formDT.append('project_id', stateData.projectId);
        formDT.append('project_process', stateData.projectProcess);
        formDT.append('project_is_cancel', stateData.projectIsCancel);
        formDT.append('project_barang_foto_nota_id', data.deleteId);
        formDT.append('project_barang_foto_nota_name', data.deleteName);

        axios({
            method: 'post',
            url: BE_API_TWO + '/delete_project_barang_foto_nota',
            data: formDT,
            headers: formDTHeader,
        }).then((response) => {
            if (!mountedRef.current) return null;

            setData(d => ({ ...d, deleteLoading: false, deleteModal: false }));

            if (response.data.flag_status === 'isset') {
                fnOnChange(response.data.data);
            }

            if (response.data.flag_status === 'error') {
                notifications.show({
                    id: notificationId.current.errorDeleteData,
                    title: utils.notification.warning.caption,
                    message: response.data.pesan,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: true,
                })
            }

            if (response.data.flag_status === 'no-data') {
                setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        type: utils.modalResponse.warning,
                        hideOnClickOutSide: true,
                        content: 'Data tidak ditemukan.',
                        show: true
                    }
                }))
            }

            if (response.data.flag_status === 'invalid-json-token') {
                handleSetLoginContext(null);
            }

            if (response.data.flag_status === 'user-inactive') {
                handleSetLoginContext(null);
            }
        }).catch(error => {
            if (!mountedRef.current) return null;

            setData(d => ({
                ...d,
                deleteLoading: false,
                deleteModal: false
            }))

            notifications.show({
                id: notificationId.current.errorDeleteData,
                title: utils.notification.warning.caption,
                message: error.message,
                color: utils.notification.warning.color,
                icon: utils.notification.warning.icon,
                withBorder: true,
                autoClose: true,
            })
        })
    }

    return (
        <React.Fragment>
            <InputWrapperCustom
                stateLabel={
                    <Group position='apart' mb='.5rem'>
                        <Group spacing={5}>
                            <LabelWithAsterisk stateLabel={stateData.data.label} />
                            <Text>({Array.isArray(stateData.data.value) ? stateData.data.value.length : 0})</Text>
                        </Group>
                    </Group>
                }
                stateWithAsterisk={false}
                stateError={stateData.data.error}
                stateDescription={stateData.data.description}
                stateLabelFullWidth={true}
            >
                {Array.isArray(stateData.data.value) && (stateData.data.value.length > 0) &&
                    <Carousel
                        withIndicators={false}
                        withControls={Array.isArray(stateData.data.value) && (stateData.data.value.length > 1)}
                        height={heightImage}
                        slideSize="33.333333%"
                        slideGap="xs"
                        loop
                        align="start"
                        mt='md'
                    >
                        {Array.isArray(stateData.data.value) && Object.keys(stateData.data.value).map((keyFB, index) => {
                            return (
                                <Carousel.Slide key={keyFB}>
                                    <Box
                                        sx={{
                                            position: 'relative',
                                            height: heightImage + 'px'
                                        }}
                                    >
                                        <img
                                            alt={`foto-barang-${index}`}
                                            src={`${ROOT_BASE_URL}${stateData.data.value[keyFB].foto_barang_nota_name}`}
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'cover'
                                            }}

                                            onClick={() => fnClickPhoto({
                                                images: stateData.data.value,
                                                title: 'Foto Barang',
                                                index: Number(keyFB),
                                                fieldName: 'foto_barang_nota_name',
                                                show: true,
                                            })}
                                        />

                                        <Box
                                            px='.5rem'
                                            sx={(tema) => ({
                                                height: '30px',
                                                backgroundColor: tema.fn.rgba('#404040', 0.75),
                                                position: 'absolute',
                                                bottom: 0,
                                                left: 0,
                                                right: 0,
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                cursor: 'pointer'
                                            })}

                                            onClick={() => setData(d => ({
                                                ...d,
                                                deleteId: stateData.data.value[keyFB].foto_barang_nota_id,
                                                deleteName: stateData.data.value[keyFB].foto_barang_nota_name,
                                                deleteModal: true
                                            }))}
                                        >
                                            <Text color="#fff"> {String(Number(keyFB) + 1)}</Text>

                                            <IconTrash
                                                size={18}
                                                color='#fff'
                                            />
                                        </Box>
                                    </Box>
                                </Carousel.Slide>
                            )
                        })}
                    </Carousel>
                }

                <BarangProjectNotaFotoFileInput
                    stateData={{
                        projectId: stateData.projectId,
                        projectProcess: stateData.projectProcess,
                        projectIsCancel: stateData.projectIsCancel,
                        userAccess: stateData.userAccess,
                    }}

                    fnOnAdded={(dataArray) => {
                        fnOnChange(dataArray);
                    }}
                />
            </InputWrapperCustom>

            <ModalResponse
                stateShow={data.modalResponse.show}
                fnHide={() => setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        show: false
                    }
                }))}

                stateHideOnClickOutSide={data.modalResponse.hideOnClickOutSide}
                stateType={data.modalResponse.type}
                stateContent={data.modalResponse.content}
            />

            <ModalTakeAction
                stateShow={data.deleteModal}
                fnHide={() => setData(d => ({ ...d, deleteModal: false }))}

                stateHideOnClickOutSide={true}
                stateTitle={String('Confirmation').toUpperCase()}
                stateOverlayZIndex={201}

                stateButtonClosePx='md'

                stateButtonActionCaption='Hapus'
                stateButtonActionPx='xs'
                stateButtonActionColor="red"
                stateButtonActionLoading={data.deleteLoading}
                fnButtonAction={deleteData}
            >
                <Text size='sm'>
                    Hapus foto ini ?
                </Text>
            </ModalTakeAction>
        </React.Fragment>
    )
}

export default BarangProjectNotaFoto;